'use client';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import { RecipeStepProps } from '@repo/ui/src/types';
import Loading from '@components/Loading';
import RecipeStep from './_RecipeStep';
import Markdown from '@repo/ui/src/components/Markdown';

interface Props {
  loading?: boolean;
  steps?: Array<RecipeStepProps>;
  unitOfMeasure: number;
  beforeYouGetStarted?: {
    title: string;
    summary: string;
  };
  _testID: string;
}

const RecipeSteps = ({ loading, steps, unitOfMeasure, beforeYouGetStarted, _testID }: Props) => {
  const { t } = useTranslation();

  if (loading) {
    return (
      <>
        <h4 className="tra-text-web-heading-4 tw-text-left">{t('recipeContent.stepsLabel')}</h4>{' '}
        <Loading color="brand" />
      </>
    );
  }

  if (!steps?.length) return null;

  return (
    <>
      {beforeYouGetStarted && (
        <>
          <h4 className="tra-text-web-heading-4 tw-text-left tw-pt-10 md:tw-pt-0 tw-mb-8">
            {beforeYouGetStarted.title}
          </h4>
          <Markdown bodySize="large">{beforeYouGetStarted.summary}</Markdown>
          <hr className="tw-my-8" />
        </>
      )}
      <h4 className="tra-text-web-heading-4 tw-text-left tw-pt-10 md:tw-pt-0">
        {t('recipeContent.stepsLabel')}
      </h4>
      <ul className="tw-list-none tw-pl-0">
        {steps?.map((step, i) => (
          <li
            key={i}
            data-test-id={`${_testID}_recipe_step_${i + 1}`}
            className="tw-list-none tw-border-b last:tw-border-b-0 tw-border-transparent-light-300"
          >
            <RecipeStep step={step} unitOfMeasure={unitOfMeasure} index={i} />
          </li>
        ))}
      </ul>
    </>
  );
};
export default RecipeSteps;
